import { Component, Input, OnInit } from '@angular/core';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { getContrastYIQ } from '@stockaid/utils';
import _ from 'lodash';

@Component({
  selector: 'kendo-select-filter',
  templateUrl: './kendo-select-filter.component.html',
  styleUrls:['./kendo-select-filter.component.scss']
})
export class KendoSelectFilterComponent implements OnInit {
  @Input() public filter: CompositeFilterDescriptor;
  @Input() public filterService: any; // Type as any so it accepts both Grid and TreeList FilterService
  @Input() public data: any[];
  @Input() public textField: string;
  @Input() public valueField: string;
  @Input() public field: string;
  @Input() private isMenu = false;
  @Input() public multiple: boolean = false;
  serviceLevelData: any[];

  readonly getContrastYIQ = getContrastYIQ;

  private _cachedSelectedValues: any[] = [];

  public get selectedValue(): any {
    if (this.multiple) {
      const filters = this.filtersByField(this.field);
      const values = filters.map((f) => f.value);
      // Only return a new array if the values actually changed
      // This prevents Kendo from re-rendering the popup on every change detection cycle
      if (
        values.length !== this._cachedSelectedValues.length ||
        values.some((v, i) => v !== this._cachedSelectedValues[i])
      ) {
        this._cachedSelectedValues = values;
      }
      return this._cachedSelectedValues;
    }
    const filter = this.filterByField(this.field);
    return filter ? filter.value : null;
  }

  // --- BaseFilterCellComponent equivalents ---
  public filtersByField(field: string): FilterDescriptor[] {
      return (this.filter?.filters || [])
          .filter(f => (f as FilterDescriptor).field === field) as FilterDescriptor[];
  }

  public filterByField(field: string): FilterDescriptor {
      return this.filtersByField(field)[0];
  }

  public removeFilter(field: string): void {
      const index = (this.filter?.filters || []).findIndex(
          f => (f as FilterDescriptor).field === field
      );
      if (index >= 0) {
          this.filter.filters.splice(index, 1);
      }
  }

  public updateFilter(filter: FilterDescriptor): void {
      const index = (this.filter?.filters || []).findIndex(
          f => (f as FilterDescriptor).field === filter.field
      );
      if (index >= 0) {
          this.filter.filters.splice(index, 1, filter);
      } else {
          this.filter.filters.push(filter);
      }
  }

  public applyFilter(filter: CompositeFilterDescriptor): void {
      if (this.filterService) {
        this.filterService.filter(filter);
      }
  }
  // -------------------------------------------

  public get defaultItem(): any {
    return {
      [this.textField]: 'Select item...',
      [this.valueField]: null,
    };
  }

  ngOnInit(): void {
    if(this.field === 'serviceLevel') {
      this.serviceLevelData = _.cloneDeep(this.data);
      this.serviceLevelData.shift();
    }
  }

  public onChange(value: any): void {
    if (!this.filter) {
      this.filter = { logic: 'and', filters: [] };
    }

    if(this.multiple){
      if(Array.isArray(value) && value?.length){
        const filters = value.map((v) => ({
          field: this.field,
          operator: 'eq',
          value: v,
        }));

        this.filter.filters.push({
          logic: 'or',
          filters: filters,
        });

        this.filterService.filter({
          logic: 'or',
          filters: filters,
        });
      } else {
        this.filterService.filter({
          logic: 'or',
          filters: [],
        });
      }
    } else {
      value === null 
      ? this.removeFilter(this.field)
      : this.updateFilter({
        field: this.field,
        operator: 'eq',
        value: value,
      });

      if (!this.isMenu) {
        this.applyFilter(this.filter);
      }
    }
  }
}
